module.exports = __webpack_public_path__ + "static/media/quote-bg.670ef983.jpg";